import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@app/directives/_vehicle/_vehicle.directives.module";
import { FoundationCsvImporterComponent } from "@app/main/modules/foundation/_components/foundation-csv-importer/foundation-csv-importer.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { ManualTestContainerComponent } from "@foundation/_components/manual-test-container/manual-test-container.component";
import { DeviceInstallEditor } from "@foundation/_routes/commissions/commissionEditor/components/deviceInstallEditor/device-install-editor.component";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { FoundationComponentsModule } from "../../_components/components.modules";
import { CommissionDetailComponent } from "./commission-detail/commission-detail.component";
import { CommissionSummaryComponent } from "./commission-detail/commission-summary/commission-summary.component";
import { CommissionListComponent } from "./commission-list.component";
import { VCommissionEditorComponent } from "./commissionEditor/commission-editor.component";
import { AddVehicleComponent } from "./commissionEditor/components/add-vehicle/add-vehicle.component";
import { NewCommissionDetailComponent } from "./commissionEditor/components/new-commission-detail/new-commission-detail.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    DeviceInstallEditor,
    ManualTestContainerComponent,
    CommissionListComponent,
    CommissionDetailComponent,
    VCommissionEditorComponent,
    NewCommissionDetailComponent,
    CommissionSummaryComponent,
    AddVehicleComponent,
    FoundationCsvImporterComponent
];

const declarations: any[] = [
];

const providers: any[] = [
];

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        FormsDirectivesModule,
        VeriDirectivesModule,
        FoundationComponentsModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        VehicleDirectivesModule,
        ResourceFiltersDirectivesModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [/*NO_ERRORS_SCHEMA*/]
})
export class CommissionModule {
    constructor() {
    }
}
